// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-b6b34486]{background-color:var(--el-color-white);border-radius:5px;font-size:13px;padding:20px;line-height:28px}", ""]);
// Exports
module.exports = exports;
